export const wsServerUrl = process.env.REACT_APP_WS_BASE_URL;
